import React from "react";

export const About = ({ data }) => {
  if (!data) {
    return <div id="about">loading...</div>;
  }

  return (
    <div id="about" className="py-5">
      <div className="container">
        {/* Überschrift + Einleitung */}
        <div className="section-title text-center mb-4">
          <h2 className="rules-title">Unsere Düsseldorfer Clubs</h2>
          <div className="about-text text-center">
  {data.paragraph
    .split(/\n\n/) // Absätze anhand von \n\n trennen
    .map((para, idx) => (
      <p key={idx}>{para}</p>
    ))}
</div>
        </div>

        {/* Kacheln */}
        <div className="row g-4">
          {(data.clubs || []).map((club, idx) => (
            <div className="col-12 col-sm-6 col-lg-4" key={idx}>
              <div className="card h-100 text-center club-card">
                <div className="about-text mb-4 text-center">
                  <h3 className="h5 mb-3">{club.name}</h3>
                      <p className="mb-0">{club.desc}</p>
                    
                </div>
                                {club.url ? (
                    <a
                      href={club.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary mt-auto mb-3"
                    >
                      Zur Webseite
                    </a>
                  ) : (
                    <button className="btn btn-secondary" disabled>
                      Kein Link vorhanden
                    </button>
                  )}
              </div>
            </div>
          ))}
        </div>
      
      </div>
    </div>
  );
};